import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  success: { backgroundColor: '#024787' },
  error: { backgroundColor: '#024787' },
  warning: { backgroundColor: '#024787' },
  info: { backgroundColor: '#024787' },
}));

export { useStyles };
